(ns minorodata.components.feature-request.core
  (:require ["featurebase-js" :refer [initEmbedWidget]]
            [minorodata.app.featurebase :as featurebase]
            [react :as react]
            [re-posh.core :as re-posh]
            [ui.page :refer [page-content page-header page-root page-title]]))

(defn- ->embed-config
  [dark-mode?]
  {:embedOptions   {:path "/"}
   :stylingOptions {:theme    (featurebase/dark-mode->theme dark-mode?)
                    :hideMenu true
                    :hideLogo true}})

(defn- embed
  []
  (let [dark-mode? @(re-posh/subscribe [:app/prop :app/dark-mode?])
        ready?     (featurebase/ready?)]

    (react/useEffect
     (fn []
       (when ready?
         (try
           (initEmbedWidget (clj->js (->embed-config dark-mode?)))
           (catch :default error
             (js/console.warn "Featurebase: initEmbedWidget failed")
             (js/console.error error))))
       js/undefined)
     #js [ready? dark-mode?])

    [:div {:data-featurebase-embed true
           :class                  "h-full min-h-[85vh]"}]))

(defn page
  []
  [page-root
   [page-header {:variant :border}
    [page-title "Feature requests"]]
   [page-content {:variant :border}
    [:f> embed]]])
